/*!
 * AccordionView - Vue accordéon hiérarchique pour IconsView
 * Présentation moderne avec modules de premier niveau, branches repliables et éléments terminaux
 */

import BaseView from './BaseView';

export default class AccordionView extends BaseView {
    constructor(plugin, name = 'accordion') {
        super(plugin, name);
    }

    createContainer(element) {
        const myself = this.plugin;
        myself.viewItemWidthRatio = 0;
        myself.viewItemThumbsMode = false;
        this.container = $('<ul class="iv__accordion iv__container"></ul>');
        myself.container = this.container;

        myself.containerView.addClass('iv__view iv__view--' + this.name + ' view view-' + this.name);
        element.append(this.container);
        if (myself.preview) {
            element.append(myself.preview);
        }

        return this.container;
    }

    resize() {
        if (this.container) {
            this.container.find('.iv__item').css({ width: '', minWidth: '' });
        }
    }

    renderIcon(data, container, subdir, path = []) {
        const myself = this.plugin;
        myself.viewItemWidthRatio = 0;
        myself.viewItemThumbsMode = false;
        const currentType = this.getTypes(data);
        const currentClassAll = this.buildItemClasses(data, currentType, (data.class || data.cls || ''));
        const hasChildren = (data.childs && Array.isArray(data.childs) && data.childs.length > 0);
        const depth = path.length;

        // Détection du rôle / niveau hiérarchique
        const isModule = (data.type === 'module' || depth <= 1);
        const isBranch = (data.type === 'branch' || (depth === 2 && hasChildren));

        // Préparation de l'icône
        let iconHtml = '';
        if (data.glyph) {
            const g = data.glyph.startsWith('fa-') ? data.glyph : ('fa-' + data.glyph);
            iconHtml = `<i class="fa-solid ${g}"></i>`;
        } else if (typeof data.icon === 'string' && data.icon.startsWith('fa-')) {
            iconHtml = `<i class="fa-solid ${data.icon}"></i>`;
        } else if (data.icon) {
            iconHtml = myself.renderIconImage(16, data.icon, data, 'img');
        } else {
            iconHtml = '<i class="fa-solid fa-cube"></i>';
        }

        // Préparation du compteur
        let count = data.count;
        if (count === undefined && hasChildren) {
            count = data.childs.length;
        }

        let countHtml = '';
        if (count !== undefined && count !== null) {
            countHtml = `<span class="iv__accordion__count">${count}</span>`;
        }

        // Préparation du sous-statut / badge (ignorer stable)
        let subBadgeHtml = '';
        const rawStatus = data.sub || data.status;
        if (rawStatus && String(rawStatus).toLowerCase() !== 'stable') {
            const st = String(rawStatus).toLowerCase();
            subBadgeHtml = `<small class="iv__accordion__sub iv__accordion__sub--${st}">${String(rawStatus).toUpperCase()}</small>`;
        }

        const searchAttr = ((data.label || '') + ' ' + (data.id || '') + ' ' + (data.title || '') + ' ' + (data.name || '')).toLowerCase();

        let code = '';

        if (isModule && hasChildren) {
            // Niveau 0 : Module accordéon
            code = `
                <li class="iv__accordion__module ${currentClassAll}" data-id="${data.id}" data-type="module" data-search="${searchAttr}">
                    <div class="iv__accordion__module-header iv__item__preframe">
                        <span class="iv__item__expend iv__accordion__arrow" title="Déployer / Replier">
                            <i class="fa-solid fa-chevron-down"></i>
                        </span>
                        <span class="iv__accordion__module-icon">${iconHtml}</span>
                        <span class="iv__accordion__module-title iv__item__main titre">${data.label}</span>
                        ${countHtml}
                    </div>
                </li>
            `;
        } else if (isBranch && hasChildren) {
            // Niveau 1 : Branche avec sous-éléments
            code = `
                <li class="iv__accordion__branch ${currentClassAll}" data-id="${data.id}" data-type="branch" data-search="${searchAttr}">
                    <div class="iv__accordion__branch-header iv__item__preframe">
                        <span class="iv__item__expend iv__accordion__arrow" title="Déployer / Replier">
                            <i class="fa-solid fa-chevron-down"></i>
                        </span>
                        <span class="iv__accordion__branch-icon">${iconHtml}</span>
                        <a href="${data.hash || ('#' + data.id)}" class="iv__accordion__branch-title iv__item__main titre devguide-nav-link" data-id="${data.id}">${data.label}</a>
                        ${countHtml}
                    </div>
                </li>
            `;
        } else {
            // Élément terminal sélectionnable
            code = `
                <li class="iv__accordion__item ${currentClassAll}" data-id="${data.id}" data-type="${data.type || 'item'}" data-search="${searchAttr}">
                    <a href="${data.hash || ('#' + data.id)}" class="iv__item__frame iv__item__main iv__accordion__item-link devguide-nav-link" data-id="${data.id}">
                        <span class="iv__accordion__item-icon">${iconHtml}</span>
                        <span class="iv__item__name titre iv__accordion__item-text">${data.label}</span>
                        ${subBadgeHtml}
                    </a>
                </li>
            `;
        }

        const currentIcon = $(code);
        let currentIconReact = currentIcon.find('> div > .iv__item__main').first();
        if (!currentIconReact.length) {
            currentIconReact = currentIcon.find('.iv__item__main').first();
        }

        container.append(currentIcon);
        this.attachItemEvents(currentIcon, currentIconReact, data, currentType, path);
        this.renderBadge(data, currentIcon);

        // Rendu récursif des enfants
        if (hasChildren) {
            const listClass = isModule ? 'iv__accordion__module-body' : 'iv__accordion__list';
            const currentIconChilds = $(`<ul class="iv__item__childs iv__item__tree ${listClass}"></ul>`);
            currentIcon.append(currentIconChilds);

            const childsCount = myself.renderIcons(data.childs, currentIconChilds, true, path);
            if (childsCount > 0) currentIcon.addClass('iv__item--parent have-childs');

            // Déterminer l'état de déploiement
            const expandKey = (data.type || 'item') + '-' + data.id;
            let shouldExpand = false;

            if (myself.dataExpand[expandKey] === true) {
                shouldExpand = true;
            } else if (myself.dataExpand[expandKey] === false) {
                shouldExpand = false;
            } else if (data.expanded !== undefined) {
                shouldExpand = Boolean(data.expanded);
            } else if (isModule && depth <= 1) {
                shouldExpand = true;
            } else if (myself.options.expand) {
                shouldExpand = true;
            }

            if (shouldExpand) {
                currentIcon.addClass('iv__item--expanded');
                myself.dataExpand[expandKey] = true;
            } else {
                currentIconChilds.hide();
            }

            // Clic sur le chevron arrow pour déplier / replier
            currentIcon.find('> div > .iv__item__expend').on('click', function (e) {
                e.stopPropagation();
                e.preventDefault();
                const isExpanded = currentIcon.hasClass('iv__item--expanded');
                myself.treeExpend(currentIcon, !isExpanded);
            });

            // Pour un module, un clic sur l'en-tête (hors titre s'il a une action) bascule l'accordéon
            if (isModule) {
                currentIcon.find('> .iv__accordion__module-header').on('click', function(e) {
                    if ($(e.target).closest('.iv__item__expend').length) return;
                    const isExpanded = currentIcon.hasClass('iv__item--expanded');
                    myself.treeExpend(currentIcon, !isExpanded);
                });
            }

            // Pour une branche, clic sur l'en-tête (hors titre lien) bascule l'accordéon
            if (isBranch) {
                currentIcon.find('> .iv__accordion__branch-header').on('click', function(e) {
                    if ($(e.target).closest('.iv__item__expend, .iv__accordion__branch-title').length) return;
                    const isExpanded = currentIcon.hasClass('iv__item--expanded');
                    myself.treeExpend(currentIcon, !isExpanded);
                });
            }
        }

        return currentIcon;
    }
}
